<template>
    <hr class="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700">
    <h2 class="text-4xl font-bold text-gray-800 text-center tracking-tight" :id="title">
        {{title}}
    </h2>
    <hr class="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700">
</template>
<script>
  export default {
    name: 'ComponentTitle',
    props: {
      title: String,
    }
  }
</script>